const STATUSES_DE = {
  added: "Hinzugefügt",
  archived: "Archiviert",
  canceled: "Storniert",
  complete: "Vollständig",
  confirmed: "Steht bevor",
  ended: "Beendet",
  expired: "Abgelaufen",
  expires_soon: "Endet bald",
  incomplete: "Unvollständig",
  paid: "Bezahlt",
  paymentToCome: "Bevorstehende Zahlung",
  pending: "Ausstehend",
  proposed: "Vorgeschlagen",
  refused: "Abgelehnt",
  scheduled: "In Bearbeitung",
  sent: "In Bearbeitung",
  started: "Gestartet",
  to_add: "Hinzufügen",
  to_renew: "Zu erneuern",
  toAdd: "Hinzufügen",
  toCome: "Steht bevor",
  toCorrect: "Zu korrigieren",
  toJustify: "Zu begründen",
  toPay: "Zu bezahlen",
  up_to_date: "Aktuell",
  validated: "Validiert",
  validationInProgress: "Validierung läuft",
  waiting_for_confirmation: "Steht bevor",
  waiting_for_validation: "In Bearbeitung",
} as const;

export default STATUSES_DE;
